import React from "react";
import Loader from 'react-loader-spinner'
import HttpService from '../../utils/Http.services';
import { checkTranslation, translate, setObject } from "../../utils/useful";

class SelectInput extends React.Component {
    state = {
        options: [],
        isLoading: false
    }

    componentDidMount() {
        this.init(true)
    }


    componentDidUpdate(prevProps) {

        // console.log(this.props.data)

        if (this.state.options != this.props.header.information.items && this.props.header.information.type === "local") {
            this.setState({ options: this.props.header.information.items })
        }
    }

    init(mount) {


        // if(!mount){
        //     this.props.changeValue(this.props.header.key, null, this.props.extra) 
        // }
        if (this.props.header.information) {
            if (this.props.header.information.type === "local") {
                this.setState({ options: this.props.header.information.items })
            } else if (this.props.header.information.type === "api") {
                this.fetch()
            }
        }

    }



    fetch() {

        // console.log("HERE")
        // console.log(this.props.header.information.filter)
        let filter = this.props.header.information.filter
        if (this.props.header.information.sort) {
            filter.sort = this.props.header.information.sort
        }

        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
                // console.log("VAR")
            }
        }

        if (filter.filter) {
            for (const [key, value] of Object.entries(filter.filter)) {
                if (/\{\{(.*?)\}\}/.test(value)) {

                    if (this.props.variables) {
                        filter.filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                    // console.log("VAR")
                }
            }
        }

        // console.log(filter)
        // console.log(this.props.variables)
        this.setState({ isLoading: true })
        // console.log('this.props.header.information.address', this.props.header.information.address)
        HttpService.request(this.props.header.information.address, filter, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log('fetchErrorobject', fetchError)
                return
            }
            // console.log(fetchResult)
            var newData = []
            fetchResult.info.forEach(element => {

                var newTitle = this.spliter(element, this.props.header.information.fields.title)
                var newValue = this.spliter(element, this.props.header.information.fields.value)

                newData.push({ value: newValue, title: newTitle })
            });
            // console.log("NEW DATA")
            // console.log(newData)
            // setTimeout(() => {
            // console.log(this.props.data)

            if (this.props.data != null) {
                let found = false
                // console.log(this.props.data)
                let dataKey = typeof this.props.data == 'object' ? this.props.data._id : this.props.data

                //   console.log(dataKey)
                newData.forEach(element => {
                    // console.log(element.value)
                    // console.log(element.value )

                    if (element.value == dataKey) {
                        // console.log("FOUND")
                        found = true
                    }

                });

                if (found == false) {
                    // console.log("DWLKFJWLK")
                    // this.props.changeValue(this.props.header.key, null, this.props.extra)
                }

            } else if (this.props.header.information.defaultUser) {
                newData.forEach(element => {
                    if (element.value == this.props.variables?.userId) {
                        this.props.changeValue(this.props.header.key, element.value, this.props.extra)

                    }

                });
            }


            this.setState({
                options: newData,
                isLoading: false
            })
            // }, 1000);


        })

    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] === condition) {
                return true
            }
        }
        return false
    }


    changeValue = (e) => {
        let value = e.target.value
        if (value == '') {
            value = null
        }

        if (value != null && this.props.header.information?.updateAfterSelect) {
            const selected = this.state.options?.find((option) => String(option.value) === String(value))
            if (selected) {
                const titleField = this.props.header.information.fields?.title
                value = { _id: value }
                if (titleField) {
                    value = setObject(value, titleField, selected.title)
                }
            }
        }

        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }


    render() {
        let dataValue = ''
        if (this.props.data != null) {
            dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        }


        return (
            <div className='w-100' style={{ position: 'relative' }}>
                <div style={{ position: 'relative' }}>
                    <select value={dataValue} disabled={this.props.disabled || this.props.header.information?.disabled} onChange={e => { this.changeValue(e) }} className=' form-control' style={{ WebkitAppearance: 'none', border: 'none', boxShadow: 'none', backgroundColor: 'transparent', color: '#3b3a40', width: '100%', padding: 0 }}>
                        <option disabled={this.props.header.information.required ? true : false} hidden={this.props.header.information.required ? true : false} value={''}>{translate('Select')}</option>
                        {Array.isArray(this.state.options) && this.state.options?.map((prop, index) => {

                            return (
                                <option key={index} value={checkTranslation(prop.value)}>{(prop.department ? checkTranslation(prop.department) : '') + (prop.post ? checkTranslation(prop.post) : '') + checkTranslation(prop.title)}</option>
                                // <option key={index} value={prop.value}>محمد حسین محسنی / شرکت فناوری و تحقیقات صنعتی / مدیریت مرکزی بخش صنایع</option>
                            )
                        })}
                    </select>

                    {this.conditionalSettings('showInfo', true) && (
                        <p onClick={() => { if (!this.state.isLoading) { this.props.showInfo(this.props.header.information.filter, this.props.data, this.props.settings.url, this.props.settings.page) } }} style={{ fontSize: 13, color: this.state.isLoading ? '#789' : '#007aff', marginTop: 3, cursor: 'pointer', marginLeft: 3 }}>{translate('Show information')}</p>
                    )}

                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: 4, right: 25 }}>
                            <Loader
                                type="Oval"
                                color="rgba(0,122,255,1)"
                                height="25"
                                width="25"
                            />
                        </div>
                    )}

                </div>

            </div>
        );
    }
}

export default SelectInput;
